import './PinPad.css';

/**
 * Big numeric keypad for the cart (§3: "tap your name, enter your PIN. Fast,
 * seconds"). Part of the shared component layer.
 *
 * Keys are ≥56px on the cart per §0.5, and the whole pad stays usable at phone
 * width so the same code runs on a phone during the 10 test calls (§10).
 */
export function PinPad({
  value,
  onChange,
  maxLength = 6,
  disabled = false,
}: {
  value: string;
  onChange: (next: string) => void;
  maxLength?: number;
  disabled?: boolean;
}) {
  const push = (d: string) => {
    if (disabled || value.length >= maxLength) return;
    onChange(value + d);
  };

  const back = () => {
    if (disabled) return;
    onChange(value.slice(0, -1));
  };

  return (
    <div className="pinpad">
      <div className="pinpad__dots" aria-live="polite" aria-label={`${value.length} digits entered`}>
        {Array.from({ length: maxLength }, (_, i) => (
          <span key={i} className={`pinpad__dot ${i < value.length ? 'pinpad__dot--on' : ''}`} />
        ))}
      </div>
      <div className="pinpad__keys">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
          <button key={d} type="button" className="pinpad__key" onClick={() => push(d)} disabled={disabled}>
            {d}
          </button>
        ))}
        <span />
        <button type="button" className="pinpad__key" onClick={() => push('0')} disabled={disabled}>
          0
        </button>
        <button
          type="button"
          className="pinpad__key pinpad__key--soft"
          onClick={back}
          disabled={disabled || value.length === 0}
          aria-label="Delete last digit"
        >
          ⌫
        </button>
      </div>
    </div>
  );
}
